import passageInstruction from '../sounds/spanish/clpl_passage_instructions.mp3';
import directionInstruction from '../sounds/spanish/clpl_direction.mp3';
import clickOk from '../sounds/spanish/clpl_click_ok.mp3';
import scrollIntroInstruction from '../sounds/spanish/clpl_scroll_intro.mp3';
import scrollDownInstruction from '../sounds/spanish/clpl_scroll_down.mp3';
import scrollReadyInstruction from '../sounds/spanish/clpl_ready.mp3';
import scrollInstruction from '../sounds/spanish/clpl_ready_instructions.mp3';
import scrollReadyClickOk from '../sounds/spanish/clpl_ready_click_ok.mp3';
import modelCorrectResponse from '../sounds/spanish/clpl_model_correct_answer_selected.mp3';
import modelIncorrectResponse from '../sounds/spanish/clpl_model_incorrect_answer_selected.mp3';
import modelSecondIncorrectResponse from '../sounds/spanish/clpl_model_incorrect_answer_selected_twice.mp3';
import modelInstructionStart from '../sounds/spanish/clpl_model_sentence_start.mp3';
import modelInstructionEnd from '../sounds/spanish/clpl_model_sentence_end.mp3';
import modelOptionOne from '../sounds/spanish/clpl_model_option_one.mp3';
import modelOptionTwo from '../sounds/spanish/clpl_model_option_two.mp3';
import modelOptionThree from '../sounds/spanish/clpl_model_option_three.mp3';
import practiceIntro from '../sounds/spanish/clpl_practice_intro.mp3';
import practiceEnd from '../sounds/spanish/clpl_practice_sentence_end.mp3';
import practiceOptionOne from '../sounds/spanish/clpl_practice_option_one.mp3';
import practiceOptionTwo from '../sounds/spanish/clpl_practice_option_two.mp3';
import practiceOptionThree from '../sounds/spanish/clpl_practice_option_three.mp3';
import practiceCorrectAnswerSelected from '../sounds/spanish/clpl_practice_correct_answer_selected.mp3';
import practiceIncorrectAnswerSelected from '../sounds/spanish/clpl_practice_incorrect_answer_selected.mp3';
import practiceIncorrectAnswerSelectedTwice from '../sounds/spanish/clpl_practice_incorrect_answer_selected_twice.mp3';
import { MODEL, PRACTICE, SCROLL } from '../constants/assessmentItemType';

// Alyx Spanish Audios
import passageInstructionAlyx from '../sounds/alyx/spanish/clpl_passage_instructions_Alyx.mp3';
import directionInstructionAlyx from '../sounds/alyx/spanish/clpl_direction_Alyx.mp3';
import clickOkAlyx from '../sounds/alyx/spanish/clic_continuare_2021_Alyx.mp3';
import scrollIntroInstructionAlyx from '../sounds/alyx/spanish/clpl_scroll_intro_Alyx.mp3';
import scrollDownInstructionAlyx from '../sounds/alyx/spanish/clpl_scroll_down_Alyx.mp3';
import scrollReadyInstructionAlyx from '../sounds/alyx/spanish/clpl_ready_Alyx.mp3';
import scrollInstructionAlyx from '../sounds/alyx/spanish/clpl_ready_instructions_Alyx.mp3';
import scrollReadyClickOkAlyx from '../sounds/alyx/spanish/clpl_ready_click_ok_Alyx.mp3';
import modelCorrectResponseAlyx from '../sounds/alyx/spanish/clpl_model_correct_answer_selected_Alyx.mp3';
import modelIncorrectResponseAlyx from '../sounds/alyx/spanish/clpl_model_incorrect_answer_selected_Alyx.mp3';
import modelSecondIncorrectResponseAlyx from '../sounds/alyx/spanish/clpl_model_incorrect_answer_selected_twice_Alyx.mp3';
import modelInstructionStartAlyx from '../sounds/alyx/spanish/clpl_model_sentence_start_Alyx.mp3';
import modelInstructionEndAlyx from '../sounds/alyx/spanish/clpl_model_sentence_end_Alyx.mp3';
import modelOptionOneAlyx from '../sounds/alyx/spanish/clpl_model_option_one_Alyx.mp3';
import modelOptionTwoAlyx from '../sounds/alyx/spanish/clpl_model_option_two_Alyx.mp3';
import modelOptionThreeAlyx from '../sounds/alyx/spanish/clpl_model_option_three_Alyx.mp3';
import practiceIntroAlyx from '../sounds/alyx/spanish/clpl_practice_intro_Alyx.mp3';
import practiceEndAlyx from '../sounds/alyx/spanish/clpl_practice_sentence_end_Alyx.mp3';
import practiceOptionOneAlyx from '../sounds/alyx/spanish/clpl_practice_option_one_Alyx.mp3';
import practiceOptionTwoAlyx from '../sounds/alyx/spanish/clpl_practice_option_two_Alyx.mp3';
import practiceOptionThreeAlyx from '../sounds/alyx/spanish/clpl_practice_option_three_Alyx.mp3';
import practiceCorrectAnswerSelectedAlyx from '../sounds/alyx/spanish/clpl_practice_correct_answer_selected_Alyx.mp3';
import practiceIncorrectAnswerSelectedAlyx from '../sounds/alyx/spanish/clpl_practice_incorrect_answer_selected_Alyx.mp3';
import practiceIncorrectAnswerSelectedTwiceAlyx from '../sounds/alyx/spanish/clpl_practice_incorrect_answer_selected_twice_Alyx.mp3';
import { selectAvatarAudio } from '../common/alex/AlexUtils';

const CLPL_INSTRUCTIONS = {
    passageInstruction: selectAvatarAudio(passageInstruction, passageInstructionAlyx),
    [MODEL]: {
        directionInstruction: selectAvatarAudio(directionInstruction, directionInstructionAlyx),
        modelCorrectResponse: selectAvatarAudio(modelCorrectResponse, modelCorrectResponseAlyx),
        modelIncorrectResponse: selectAvatarAudio(modelIncorrectResponse, modelIncorrectResponseAlyx),
        modelSecondIncorrectResponse: selectAvatarAudio(modelSecondIncorrectResponse, modelSecondIncorrectResponseAlyx),
        modelInstructionStart: selectAvatarAudio(modelInstructionStart, modelInstructionStartAlyx),
        modelInstructionEnd: selectAvatarAudio(modelInstructionEnd, modelInstructionEndAlyx),
        modelOptionOne: selectAvatarAudio(modelOptionOne, modelOptionOneAlyx),
        modelOptionTwo: selectAvatarAudio(modelOptionTwo, modelOptionTwoAlyx),
        modelOptionThree: selectAvatarAudio(modelOptionThree, modelOptionThreeAlyx),
        clickOk: selectAvatarAudio(clickOk, clickOkAlyx),
    },
    [PRACTICE]: {
        practiceIntro: selectAvatarAudio(practiceIntro, practiceIntroAlyx),
        practiceEnd: selectAvatarAudio(practiceEnd, practiceEndAlyx),
        practiceOptionOne: selectAvatarAudio(practiceOptionOne, practiceOptionOneAlyx),
        practiceOptionTwo: selectAvatarAudio(practiceOptionTwo, practiceOptionTwoAlyx),
        practiceOptionThree: selectAvatarAudio(practiceOptionThree, practiceOptionThreeAlyx),
        practiceCorrectAnswerSelected: selectAvatarAudio(practiceCorrectAnswerSelected, practiceCorrectAnswerSelectedAlyx),
        practiceIncorrectAnswerSelected: selectAvatarAudio(practiceIncorrectAnswerSelected, practiceIncorrectAnswerSelectedAlyx),
        practiceIncorrectAnswerSelectedTwice: selectAvatarAudio(practiceIncorrectAnswerSelectedTwice, practiceIncorrectAnswerSelectedTwiceAlyx),
        clickOk: selectAvatarAudio(clickOk, clickOkAlyx),
    },
    [SCROLL]: {
        scrollIntroInstruction: selectAvatarAudio(scrollIntroInstruction, scrollIntroInstructionAlyx),
        scrollDownInstruction: selectAvatarAudio(scrollDownInstruction, scrollDownInstructionAlyx),
        scrollReadyInstruction: selectAvatarAudio(scrollReadyInstruction, scrollReadyInstructionAlyx),
        scrollInstruction: selectAvatarAudio(scrollInstruction, scrollInstructionAlyx),
        scrollReadyClickOk: selectAvatarAudio(scrollReadyClickOk, scrollReadyClickOkAlyx),
        clickOk: selectAvatarAudio(clickOk, clickOkAlyx),
    },
};

export default CLPL_INSTRUCTIONS;
